let dataServe = "https://cr.apmem.com";

let dataPool = {
  //获取Token字符串
  getToken: dataServe + "/App/GetToken",
  //获取所属行业列表信息
  getIndustryInfoList: dataServe + "/App/GetIndustryInfoList",
  //获取人员类别列表信息
  getMenTypeList: dataServe + "/App/GetMenTypeList",
  //获取期次类型列表信息
  getPeriodTypeList: dataServe + "/App/GetPeriodTypeList",
  //获取期次列表信息
  getPeriodInfoList: dataServe + "/App/GetPeriodInfoList",
  //获取所属区域列表信息
  getAreaInfoList: dataServe + "/App/GetAreaInfoList",
  //获取集团公司列表信息
  getCompanyGroupList: dataServe + "/App/GetCompanyGroupList",
  //获取职务或工种列表信息
  getWorkTypeList: dataServe + "/App/GetWorkTypeList",
  //删除报名上传附件
  removeSignUpAttachFile: dataServe + "/App/RemoveSignUpAttachFile",
  //提交报名信息
  signUpByUser: dataServe + "/App/SignUpByUser",
  //查询报名信息
  querySignUpStatus: dataServe + "/App/QuerySignUpStatus",
  //请求工行支付参数【培训服务费及住宿押金】
  payForIcbc: dataServe + "/App/PayForIcbc",
  //请求工行支付参数【仅培训服务费】
  payForIcbcForTrain: dataServe + "/App/PayForIcbcForTrain",
  //请求工行支付参数【仅住宿押金】
  payForIcbcForDeposit: dataServe + "/App/PayForIcbcForDeposit",
  //查询在线支付结果（5秒调用一次）
  queryPayResult: dataServe + "/App/QueryPayResult",
  //根据身份证号码、验证码查询学员培训档案打印信息
  queryPrintTrainDataByIDCard: dataServe + "/App/QueryPrintTrainDataByIDCard",
  //根据报名编号、验证码查询培训档案打印信息
  queryPrintTrainDocById: dataServe + "/App/QueryPrintTrainDocById",
  //根据报名编号、验证码查询学时证明打印信息
  queryPrintProveById: dataServe + "/App/QueryPrintProveById",
  //查询学员报名历史记录信息
  queryFrontSignUpInfo: dataServe + "/App/QueryFrontSignUpInfo"
};

export default dataPool;


// WEBPACK FOOTER //
// ./src/api/data.js